import { Fragment, type ReactNode } from "react"
import { HeroDevice } from "@seamapi/device-illustrations/HeroDevice"
import { useHeroMotion } from "@seamapi/device-illustrations/useHeroMotion"
import styles from "./AuthPageContainer.module.css"

const devices = [
  { kind: "yale", label: "Access", name: "Yale Assure Lock 2" },
  { kind: "nest", label: "Climate", name: "Nest Learning Thermostat" },
  { kind: "minut", label: "Sensors", name: "Minut Home Sensor" },
  { kind: "camera", label: "Cameras", name: "Ubiquiti G6 Turret" },
] as const

/** Workbench direction 02, composed for the console's account-entry screen. */
export function AuthDeviceMatrix({ children }: { children: ReactNode }) {
  const { artwork, motion, paused } = useHeroMotion()

  return (
    <div ref={artwork} className={styles.artwork} data-paused={paused}>
      <div className={styles.matrix}>
        {devices.map(({ kind, label, name }, index) => (
          <Fragment key={kind}>
            <figure className={styles.device} data-kind={kind}>
              <div className={styles.object} role="img" aria-label={name}>
                <div inert aria-hidden="true" className={styles.model}>
                  <HeroDevice
                    kind={kind}
                    appearance="material"
                    cameraFinish="white"
                    motion={motion}
                    paused={paused}
                  />
                </div>
              </div>
              <figcaption>{label}</figcaption>
            </figure>
            {index === 1 && <div className={styles.quoteRow}>{children}</div>}
          </Fragment>
        ))}
      </div>
    </div>
  )
}
